import type { CloseRoomReason, UserCurrent } from '@api/types';
import {
    AuthMethod,
    DeleteReasons,
    RegSource,
    UserGender,
    UserType,
} from '@shared/types';

export function getUserType(user?: UserCurrent | { gender?: UserGender }): UserType {
    if (user && 'operator' in user && user?.operator) {
        return UserType.Model;
    }

    switch (user?.gender) {
        case UserGender.Male:
            return UserType.User;
        case UserGender.Female:
            return UserType.Model;
        default:
            return UserType.None;
    }
}

export function getRegSource(authMethod: AuthMethod): RegSource {
    switch (authMethod) {
        case AuthMethod.Email:
            return RegSource.Email;
        case AuthMethod.Google:
            return RegSource.Google;
        case AuthMethod.GoogleOneTap:
            return RegSource.GoogleOneTap;
        default:
            return RegSource.Unknown;
    }
}

export function getDeleteReason(reason: string, otherReason?: string): string {
    return reason !== DeleteReasons.Other ? reason : `${reason} (${otherReason})`;
}

export function getActionClosedReason(
    closeReason: 'pressStop' | 'pressSkip' | 'goneAway',
    isPlayerStarted: boolean,
    isPlayerPlaying: boolean,
    isPartnerReconnecting: boolean,
    isPartnerLeft: boolean,
    isCameraTurnedOff: boolean | undefined
): CloseRoomReason {
    if (isPartnerLeft) {
        /*
            pressStopPartnerLeft
            pressSkipPartnerLeft
            goneAwayPartnerLeft
         */
        return `${closeReason}PartnerLeft`;
    } else if (isPartnerReconnecting && !isPlayerStarted && !isCameraTurnedOff) {
        /*
            pressStopPartnerReconnectingBeforePlayerStarted
            pressSkipPartnerReconnectingBeforePlayerStarted
            goneAwayPartnerReconnectingBeforePlayerStarted
         */
        return `${closeReason}PartnerReconnectingBeforePlayerStarted`;
    } else if (isPartnerReconnecting && isPlayerStarted) {
        /*
            pressStopPartnerReconnecting
            pressSkipPartnerReconnecting
            goneAwayPartnerReconnecting
         */
        return `${closeReason}PartnerReconnecting`;
    } else if (!isPlayerStarted && !isCameraTurnedOff) {
        /*
            pressStopBeforePlayerStarted
            pressSkipBeforePlayerStarted
            goneAwayBeforePlayerStarted
         */
        return `${closeReason}BeforePlayerStarted`;
    } else if (!isPlayerPlaying && !isCameraTurnedOff) {
        /*
            pressStopPlayerNotPlaying
            pressSkipPlayerNotPlaying
            goneAwayPlayerNotPlaying
         */
        return `${closeReason}PlayerNotPlaying`;
    } else {
        return `${closeReason}`;
    }
}
